<template>
  <div class="home-page">
    <Header />
    <img
      src="@/assets/jkt/HomePage/jktgateway.png"
      alt="JKTGATEWAY"
      class="gateway-image"
    >
    <hr class="underline">
    <div class="content-wrapper">
      <div class="background-overlay" />
      <div class="content">
        <RouterLink
          v-for="item in items"
          :key="item.title"
          :to="isAccessible(item.title) ? item.route : '#'"
          class="image-container"
          :class="{ 'disabled': !isAccessible(item.title) }"
          :style="{ pointerEvents: isAccessible(item.title) ? 'auto' : 'none' }"
        >
          <img
            :src="item.image"
            :alt="item.title"
            class="box-image cursor-pointer"
            :class="{ 'blurred': !isAccessible(item.title) }"
            @mouseover="hoveredItem = item.title"
            @mouseleave="hoveredItem = ''"
          >
          <img
            :src="item.hoverImage"
            :alt="item.title"
            class="box-image hover-image"
            :class="{ 'visible': hoveredItem === item.title }"
          >
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import awamImg from '@/assets/jkt/AdminPage/awam.png'
import inspektoratImg from '@/assets/jkt/AdminPage/inspektorat.png'
import kampungImg from '@/assets/jkt/AdminPage/kampung.png'
import kawalanImg from '@/assets/jkt/AdminPage/kawalan.png'
import kesihatanImg from '@/assets/jkt/AdminPage/kesihatan.png'
import khidmatImg from '@/assets/jkt/AdminPage/khidmat.png'
import maklumatImg from '@/assets/jkt/AdminPage/maklumat.png'
import pembangunanImg from '@/assets/jkt/AdminPage/pembangunan.png'
import persekitaranImg from '@/assets/jkt/AdminPage/persekitaran.png'


//Hover
import hoverAwamImg from '@/assets/jkt/AdminPage/awam1.png'
import hoverInspektoratImg from '@/assets/jkt/AdminPage/inspektorat1.png'
import hoverKampungImg from '@/assets/jkt/AdminPage/kampung1.png'
import hoverKawalanImg from '@/assets/jkt/AdminPage/kawalan1.png'
import hoverKesihatanImg from '@/assets/jkt/AdminPage/kesihatan1.png'
import hoverKhidmatImg from '@/assets/jkt/AdminPage/khidmat1.png'
import hoverMaklumatImg from '@/assets/jkt/AdminPage/maklumat1.png'
import hoverPembangunanImg from '@/assets/jkt/AdminPage/pembangunan1.png'
import hoverPersekitaranImg from '@/assets/jkt/AdminPage/persekitaran1.png'

import { useAuthStore } from '@/store/auth'
import { ref } from 'vue'



definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


//added by abdullah 
const authStore = useAuthStore()
const roles = authStore.getRoles()


// Function to check if a user has access to a route
const isAccessible = title => {
  return roles.includes('manager') || roles.includes(title.toLowerCase())
}

const items = [
  { title: 'INSPEKTORAT', image: inspektoratImg, hoverImage: hoverInspektoratImg,  route: 'inspektorat/' },
  { title: 'PEMBANGUNAN', image: pembangunanImg, hoverImage: hoverPembangunanImg,  route: 'pembangunan/'  },
  { title: 'KESIHATAN PERSEKITARAN', image: persekitaranImg, hoverImage: hoverPersekitaranImg,  route: 'kesihatan-persekitaran/'  },
  { title: 'KEJURUTERAAN KESIHATAN UMUM', image: kesihatanImg, hoverImage: hoverKesihatanImg,  route: 'kejuruteraan-kesihatan-umum/'  },
  { title: 'KEJURUTERAAN AWAM', image: awamImg, hoverImage: hoverAwamImg,  route: 'kejuruteraan-awam/'  },
  { title: 'KAWALAN PEMAJUAN', image: kawalanImg, hoverImage: hoverKawalanImg,  route: 'kawalan-pemajuan/'  },
  { title: 'KAMPUNG BARU', image: kampungImg, hoverImage: hoverKampungImg,  route: 'kampung-baru/'  },
  { title: 'KHIDMAT PENGURUSAN', image: khidmatImg, hoverImage: hoverKhidmatImg,  route: 'khidmat-pengurusan/'  },
  { title: 'PENGURUSAN MAKLUMAT', image: maklumatImg, hoverImage: hoverMaklumatImg,  route: 'pengurusan-maklumat/'  },
]

const hoveredItem = ref('')
</script>

<style scoped>
.gateway-image {
  display: block;
  block-size: auto;
  margin-block: 0;
  margin-inline: auto;
  max-inline-size: 40%;
}

.box-image.blurred {
  cursor: not-allowed;
  filter: blur(2px);
}

.underline {
  border: none;
  border-block-start: 5px solid white;
  inline-size: 40%;
}

.home-page {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-attachment: fixed;
  background-image: url("@/assets/jkt/adminHomePage.png");
  background-position: center;
  background-size: cover;
  color: white;
  min-block-size: 100vh;
}

header {
  z-index: 2;
  padding: 10px;
  inline-size: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  padding-inline: 20px;
}

.logo {
  block-size: 30px;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: white;
  font-size: 1rem;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
}

.welcome-text {
  margin-block-start: 40px;
  text-align: center;
}

.welcome-text h1 {
  color: rgb(255, 255, 255);
  font-size: 2rem;
}

.welcome-text h2 {
  background: #2f5596;
  background-clip: text;
  font-size: 5rem;
  font-weight: bold;
  -webkit-text-fill-color: transparent;
}

.content-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 20px;
  inline-size: 100%;
}

.background-overlay {
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  border-radius: 30px;
  background: rgba(238, 237, 237, 50%);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 50%);
  inset-block: 10px;
  inset-inline: 20%;
}

.content {
  z-index: 2;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
  inline-size: 100%;
  max-inline-size: 700px;
}

.image-container {
  position: relative;
  block-size: auto;
  inline-size: 100%;
}

.box-image {
  block-size: 100%;
  inline-size: 100%;
  transition: opacity 0.3s ease-in-out;
}

.hover-image {
  position: absolute;
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.image-container:hover .hover-image {
  opacity: 1;
}

@media (max-width: 1024px) {
  .content {
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    max-inline-size: 600px;
  }

  .background-overlay {
    inset-block: 10px;
    inset-inline:15%;
  }

  .welcome-text h2 {
    font-size: 4rem;
  }
}

@media (max-width: 768px) {
  .content {
    gap: 15px;
    grid-template-columns: repeat(2, 1fr);
    max-inline-size: 500px;
  }

  .background-overlay {
    inset-block: 5px;
    inset-inline: 10%;
  }

  .welcome-text h2 {
    font-size: 3rem;
  }
}

@media (max-width: 480px) {
  .content {
    grid-template-columns: 1fr;
    max-inline-size: 300px;
  }

  .welcome-text h2 {
    font-size: 2.5rem;
  }

  .background-overlay {
    inset-block: 5px;
    inset-inline: 5%;
  }
}
</style>
